"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniaApiV1Connector = exports.SortValues = void 0;
var SortValues;
(function (SortValues) {
    SortValues["NEWEST"] = "newest";
    SortValues["PRICE_ASC"] = "price_asc";
    SortValues["PRICE_DESC"] = "price_desc";
    SortValues["BESTSELLING"] = "best_selling";
    SortValues["BRAND_ASC"] = "brand_asc";
    SortValues["BRAND_DESC"] = "brand_desc";
    SortValues["BEST_MATCH"] = "best_match";
    SortValues["STATE_POPULARITY"] = "state_popularity";
})(SortValues = exports.SortValues || (exports.SortValues = {}));
// ---------------------------------------------------------------------------------------- //
// API V1 Connector
// ---------------------------------------------------------------------------------------- //
class OmniaApiV1Connector {
    axios;
    constructor(axiosInstance) {
        this.axios = axiosInstance;
    }
    affiliateFetch = (source) => this.axios.get(`affiliates/${source}`);
    ambassadorApplicationCreate = (formData) => this.axios.post('ambassador_applications', formData, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    });
    ambassadorsFetch = (params = {}) => this.axios.get('ambassadors', { params });
    ambassadorsTopFetch = (params) => this.axios.get('ambassadors/top', {
        params,
    });
    articleDataFetch = (params) => this.axios.get(`article_data`, { params });
    articleRelatedContentFetch = (uid) => this.axios.get(`articles/related_content`, {
        params: {
            uid,
        },
    });
    authRefresh = (refresh_token) => this.axios.post('auth/refresh', {
        refresh_token,
    });
    bestSellersFetch = (params) => this.axios.get('products/best_sellers', { params });
    bestOfYearLakeFetch = (year, slug) => this.axios.get(`best_of_year/${year}/lakes/${slug}`);
    bestOfYearStateFetch = (year, abbr) => this.axios.get(`best_of_year/${year}/states/${abbr}`);
    brandAmbassadorsFetch = (slug) => this.axios.get(`brands/${slug}/ambassadors`);
    brandEventNotificationsUpdate = (slug, params) => this.axios.post(`brands/${slug}/user_notification_events`, params);
    brandFavorite = (slug, params) => this.axios.post(`brands/${slug}/favorite`, params);
    brandFetch = (slug) => this.axios.get(`brands/${slug}`);
    brandUnfavorite = (slug) => this.axios.delete(`brands/${slug}/favorite`);
    categoryBrandsFetch = (urlPath) => this.axios.get(`categories/${urlPath}/brands`);
    cartAffiliate = (params) => this.axios.post('cart/affiliate', params);
    cartAssociate = (params) => this.axios.post('cart/associate', params);
    cartPromosFetch = () => this.axios.get(`cart/promos`);
    cartRewardsPercentages = () => this.axios.get(`cart/rewards_percentages`);
    cartUpsellProductsFetch = (skus) => this.axios.get(`cart_upsell_products`, {
        params: {
            skus,
        },
    });
    cartBinsFetch = (params) => this.axios.post(`cart/bins`, params);
    cartIdFetch = (params) => this.axios.post(`cart`, params);
    emailCheck = (email) => this.axios.post(`auth/check`, { email });
    experimentUserCreate = (params) => this.axios.post(`experiment_users`, params);
    eventNotificationCreate = (params) => this.axios.post(`me/event_notifications`, params);
    eventNotificationDelete = (id) => this.axios.delete(`me/event_notifications/${id}`);
    //  not really sure on the traits type here, expand as needed
    eventIdentify = (anonymous_id, traits) => this.axios.post('events/identify', { anonymous_id, traits });
    //  not really sure on the properties type here, expand as needed
    eventTrack = (event_name, anonymous_id, properties) => this.axios.post('events/track', {
        event_name,
        anonymous_id,
        properties,
    });
    fishingReportCreate = (formData) => this.axios.post(`fishing_reports`, formData, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    });
    fishingReportFetch = (slug) => this.axios.get(`fishing_reports/${slug}`);
    fishingReportsFetch = (params) => this.axios.get(`fishing_reports`, { params });
    fishingReportsUsersFetch = () => this.axios.get('fishing_reports/users');
    forYouFishingReportsFetch = (params) => this.axios.get('for_you/fishing_reports', { params });
    forYouTrendingFishingReports = (params) => this.axios.get('for_you/trending_fishing_reports', { params });
    forYouTrendingMediaFishingReports = (params) => this.axios.get('for_you/trending_media_fishing_reports', { params });
    forYouTrendingYourLakes = (params) => this.axios.get('for_you/trending_your_lakes', { params });
    giveawayProductFetch = (slug) => this.axios.get(`giveaway_products/${slug}`);
    giveawayProductEnter = (slug, params) => this.axios.post(`giveaway_products/${slug}/enter`, params);
    giveawayProductsFetch = () => this.axios.get('giveaway_products');
    inventoryFetch = (skus) => this.axios.get(`inventory`, {
        params: {
            products: skus,
        },
    });
    kitFetch = (slug) => this.axios.get(`kits/${slug}`);
    landingPageFetch = (slug, params) => this.axios.get(`landing_pages/${slug}}`, { params });
    listFetch = (urlSlug) => this.axios.get(`lists/${urlSlug}`);
    mapClarityTilesFetch = (params) => this.axios.get('map/clarity_tiles', { params });
    mapFishingReportsFetch = (params) => this.axios.get('map/fishing_reports', { params });
    mapMediaFetch = (params) => this.axios.get('map/media', { params });
    mapPinsFetch = (params) => this.axios.get('map/pins', { params });
    mapTemperatureTilesFetch = (params) => this.axios.get('map/temperature_tiles', { params });
    mapTemperatureRealTimeTilesFetch = (params) => this.axios.get('map/temperature_real_time_tiles', { params });
    marketingNotificationsUpdate = (marketing_notifications) => this.axios.put('me/marketing_notifications', marketing_notifications);
    mediaFetch = (params) => this.axios.get(`media`, { params });
    mediaFacetsFetch = () => this.axios.get(`media/facets`);
    nearbyWaterbodiesFetch = (params) => this.axios.get(`nearby/waterbodies`, {
        params,
    });
    newsletterSubscribe = (params) => this.axios.post('newsletter/subscribe', params);
    omniaVideoFetch = (slug, params) => this.axios.get(`omnia_videos/${slug}`, { params });
    omniaVideoItemCreate = (params) => this.axios.post('omnia_video_items', params);
    omniaVideoItemUpdate = (id, params) => this.axios.put(`omnia_video_items/${id}`, params);
    omniaVideoItemDelete = (id) => this.axios.delete(`omnia_video_items/${id}`);
    omniaVideosFetch = (options = {}) => this.axios.get(`omnia_videos`, { params: options });
    organizationFetch = (slug) => this.axios.get(`organizations/${slug}`);
    organizationFishingReportsFetch = (slug, params) => this.axios.get(`organizations/${slug}/fishing_reports`, {
        params,
    });
    organizationJoin = (slug) => this.axios.post(`organizations/${slug}`);
    organizationJoinByRegistrationCode = (registration_code) => this.axios.post(`organizations`, { registration_code });
    organizationLeave = (slug) => this.axios.delete(`organizations/${slug}`);
    organizationsFetch = (params = {}) => this.axios.get(`organizations`, { params });
    pageFetch = (slug) => this.axios.get(`pages/${slug}`);
    premiumProPurchaseComplete = (params) => this.axios.post('premium_pro/purchase_complete', params);
    productFamiliesFishingReportFetch = (params) => this.axios.get(`product_families_fishing_reports`, { params });
    productFamilyComplementaryProductFamiliesFetch = (handle) => this.axios.get(`product_families/${handle}/complimentary_product_families`);
    productFamilyFetch = (handle) => this.axios.get(`product_families/${handle}`);
    productFamilyFishingReportsFetch = (handle, params) => this.axios.get(`product_families/${handle}/fishing_reports`, {
        params,
    });
    productFamilyMediaFishingReportsNearbyFetch = (handle, params) => this.axios.get(`product_families/${handle}/media_fishing_reports_nearby`, {
        params,
    });
    productFamilyRelatedProductFamiliesFetch = (handle) => this.axios.get(`product_families/${handle}/related_product_families`);
    productFamilyDescriptionFetch = (handle) => this.axios.get(`product_families/${handle}/description`);
    productFamilySummaryFetch = (handle, params = {}) => this.axios.get(`product_families/${handle}/summary`, {
        params,
    });
    productFishingReportsFetch = (sku) => this.axios.get(`products/${sku}/fishing_reports`);
    productFishingReportsNearby = (params) => {
        const { sku, lat, lng } = params;
        return this.axios.get(`products/${sku}/fishing_reports/nearby`, { params: { lat, lng } });
    };
    productFetch = (sku) => this.axios.get(`products/${sku}`);
    recentBestSellersProductFamiliesFetch = () => this.axios.get(`recent_best_sellers/product_families`);
    recommendationsFetch = (params) => {
        params.include_hidden_products ||= false;
        params.limit ||= 50;
        return this.axios.post('recommendations', params);
    };
    salesProProductFamiliesFetch = (params) => this.axios.get(`sales/pro/product_families`, {
        params,
    });
    searchDefaultsFetch = () => this.axios.get(`search_defaults`);
    seasonSpeciesTechniquesFetch = (params) => this.axios.get(`season_species`, { params });
    shippingFetch = () => this.axios.get('shipping');
    shortUrlCreate = (params) => this.axios.post(`short_urls`, params);
    speciesFetch = (urlPath) => this.axios.get(`species/${urlPath}`);
    stateAmbassadorsFetch = (slug) => this.axios.get(`states/${slug}/ambassadors`);
    stateBestSellersFetch = (slug, params) => this.axios.get(`states/${slug}/best_sellers`, {
        params,
    });
    stateBrandsFetch = (slug) => this.axios.get(`states/${slug}/brands`);
    stateFetch = (slug) => this.axios.get(`states/${slug}`);
    stateFishingReportCountsFetch = (slug, params) => this.axios.get(`states/${slug}/fishing_report_counts`, {
        params,
    });
    stateHotbaitsFetch = (slug) => this.axios.get(`states/${slug}/hotbaits`);
    stateTechniquesFetch = (slug, params) => this.axios.get(`states/${slug}/top_techniques`, {
        params,
    });
    stateTopWaterbodiesFetch = (slug, params) => this.axios.get(`states/${slug}/top_waterbodies`, {
        params,
    });
    tagProductsFetch = (tag, params) => this.axios.get(`tags/${tag}/products`, { params });
    tagProductFamiliesFetch = (tag) => this.axios.get(`tags/${tag}/product_families`);
    tagProductGroupsFetch = (tag, params) => this.axios.get(`tags/${tag}/product_groups`, { params });
    techniqueEssentialsFetch = (url_path) => this.axios.get(`techniques/${url_path}/essentials`);
    techniqueFetch = (url_path) => this.axios.get(`techniques/${url_path}`);
    techniqueKeywordFetch = (slug, ip_address) => this.axios.get(`technique_keywords/${slug}`, {
        params: { ip: ip_address },
    });
    techniqueKeywordsFetch = (params = {}) => this.axios.get(`technique_keywords`, { params });
    tournamentCreate = (params) => this.axios.post('tournaments', params);
    tournamentFetch = (slug) => this.axios.get(`tournaments/${slug}`);
    tournamentsFetch = (params) => this.axios.get(`tournaments`, { params });
    userAmbassadorsFetch = (params) => this.axios.get(`me/ambassadors`, { params });
    userAmbassadorsFetchLatest = (params) => this.axios.get(`me/ambassadors/latest`, {
        params,
    });
    userBrandsFetch = () => this.axios.get(`me/brands`);
    userChangeEmail = (params) => this.axios.post('me/change_email', params);
    userConfirm = (confirmToken, reset_password = false) => this.axios.post('auth/confirm', {
        confirm_token: confirmToken,
        reset_password,
    });
    userEventNotificationsUpdate = (slug, eventNotifications, email, exclude) => this.axios.post(`user_profiles/${slug}/user_notification_events`, {
        event_notifications: eventNotifications,
        email,
        exclude,
    });
    userFishingReportDelete = (id) => this.axios.delete(`me/fishing_reports/${id}`);
    userFishingReportsFetch = () => this.axios.get(`me/fishing_reports`);
    userFishingReportUpdate = (id, formData) => this.axios.put(`me/fishing_reports/${id}`, formData, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    });
    userFetch = () => this.axios.get('me');
    userLogin = (params) => this.axios.post('auth/login', params);
    userMapTemperatureActivate = () => this.axios.post('users/map_temperature_activate');
    userNotificationsFetch = () => this.axios.get('me/event_notifications');
    userNotificationManagementFetch = (email) => this.axios.get('me/notification_management', { params: { email } });
    userOrdersFetch = () => this.axios.get(`me/orders`);
    userOrganizationFetch = () => this.axios.get(`me/organizations`);
    userPasswordReset = (email) => this.axios.post('auth/reset', {
        username: email,
    });
    userPasswordResetConfirm = (params) => this.axios.post('auth/confirm_reset', params);
    userPremiumRewardsFetch = () => this.axios.get('me/cart/rebate');
    userPremiumRewardsApply = () => this.axios.post('me/cart/rebate');
    userProductsCreate = (params) => this.axios.post('me/products', params);
    userProductDelete = (params) => this.axios.delete('me/products', {
        data: params,
    });
    userProductsFetch = () => this.axios.get(`me/products`);
    userProfileFavorite = (slug, eventNotifications, email, exclude) => this.axios.post(`user_profiles/${slug}/favorite`, {
        event_notifications: eventNotifications,
        email,
        exclude,
    });
    userProfileFetch = (slug, params) => this.axios.get(`user_profiles/${slug}`, { params });
    userProfileFishingReportsFetch = (slug) => this.axios.get(`user_profiles/${slug}/fishing_reports`);
    userProfileUnfavorite = (slug, params) => this.axios.delete(`user_profiles/${slug}/favorite`, {
        params,
    });
    userProfileUpdate = (formData) => this.axios.put(`me/user_profile`, formData, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    });
    userProManagementFetch = () => this.axios.get('me/pro_management');
    userSignup = (params) => this.axios.post('auth/signup', params);
    userUserProfileFetch = () => this.axios.get('me/user_profile');
    userWaterbodiesFetch = () => this.axios.get('me/waterbodies');
    userWaterbodiesFetchLatest = (params) => this.axios.get(`me/waterbodies/latest`, {
        params,
    });
    userWaypointsFetch = (params = {}) => this.axios.get('me/waypoints', { params });
    userWaypointFiltersFetch = () => this.axios.get('me/waypoint_filters');
    userWaypointFilterCreate = (params) => this.axios.post('me/waypoint_filters', params);
    userWaypointFilterDelete = (id) => this.axios.delete(`me/waypoint_filters/${id}`);
    userWaypointFilterUpdate = (id, params) => this.axios.put(`me/waypoint_filters/${id}`, params);
    waterbodiesNearbyFetch = (slug_or_id, miles, limit) => this.axios.get(`waterbodies/${slug_or_id}/nearby`, {
        params: { miles, limit },
    });
    waterbodyFavorite = (slug_or_id, eventNotifications, email // email is optional when user is logged in
    ) => this.axios.post(`waterbodies/${slug_or_id}/favorite`, {
        event_notifications: eventNotifications,
        email,
    });
    waterbodyFetch = (slug_or_id) => this.axios.get(`waterbodies/${slug_or_id}`);
    waterbodyFishingReportsFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/fishing_reports`, {
        params,
    });
    waterbodyHotbaitsFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/hotbaits`, { params });
    waterbodyHotbaitFishingReportsFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/hotbait_fishing_reports`, {
        params,
    });
    waterbodyLakeBreakdownVideoFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/lake_breakdown_video`, {
        params,
    });
    waterbodyRecommendationsFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/recommendations`, {
        params,
    });
    waterbodyActivate = (slug_or_id, params) => this.axios.post(`waterbodies/${slug_or_id}/activate`, {
        params,
    });
    waterbodyAmbassadorsFetch = (slug_or_id) => this.axios.get(`waterbodies/${slug_or_id}/ambassadors`);
    waterbodySpeciesSurveyDataFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/species_survey_data`, { params });
    waterbodySummaryFetch = (slug_or_id) => this.axios.get(`waterbodies/${slug_or_id}/summary`);
    waterbodySummariesSeasonalPatternsFetch(slug_or_id, params) {
        return this.axios.get(`waterbodies/${slug_or_id}/summaries/seasonal_patterns`, { params });
    }
    waterbodySummariesSeasonalStructureFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/summaries/seasonal_structure`, { params });
    waterbodySummariesKeyForageFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/summaries/key_forage`, {
        params,
    });
    waterbodySummariesSeasonalBaitColorsFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/summaries/seasonal_bait_colors`, { params });
    waterbodyTechniquesFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/waterbody_techniques`, {
        params,
    });
    waterbodyTopSpeciesFetch = (slug_or_id, params) => this.axios.get(`waterbodies/${slug_or_id}/top_species`, {
        params,
    });
    waterbodyTournamentsFetch = (slug_or_id) => this.axios.get(`waterbodies/${slug_or_id}/tournaments`);
    waterbodyUnfavorite = (slug_or_id) => this.axios.delete(`waterbodies/${slug_or_id}/favorite`);
    waterbodyUpdateNotifications = (slug_or_id, eventNotifications, email) => this.axios.post(`waterbodies/${slug_or_id}/user_notification_events`, {
        event_notifications: eventNotifications,
        email,
    });
    /** @deprecated use water_temperature and water_temperature_recorded_at instead */
    waterbodyWaterTemperatureFetch = (slug_or_id) => this.axios.get(`waterbodies/${slug_or_id}/water_temperature`);
    waypointCreate = (formData) => this.axios.post(`waypoints`, formData, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    });
    waypointDelete = (id) => this.axios.delete(`waypoints/${id}`);
    waypointFetch = (id_hash) => this.axios.get(`waypoints/${id_hash}`);
    waypointUpdate = (id, formData) => this.axios.put(`waypoints/${id}`, formData, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    });
    waypointBulkCreate = (data) => this.axios.post('waypoints/bulk', data, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    });
    wishlistFetch = (hash) => this.axios.get(`wishlists/${hash}`);
}
exports.OmniaApiV1Connector = OmniaApiV1Connector;
